// 登录页面、404 页面、无权限页面
import wait from 'src/views/home-wait.vue'
import demo from 'src/views/demo/page-demo.vue'
import login from 'src/views/Login.vue'
import errorPage from 'src/components/page-404.vue'
import noPermission from 'src/components/page-noPermission.vue'


// 前台路由 后台路由
import front_router from "src/config/router-front-config.js"
import back_end_router from "src/config/router-back-config.js"

export default [
    // ***特别的页面
    {
        path: '',
        name: 'wait',
        component: wait,
    },
    {
        path: '/demo',
        name: 'demo',
        component: demo,
    },
    {
        path: '/login',
        name: 'login',
        component: login,
    },
    {
        path:'*',
        name:'error',
        component:errorPage,
    },
    {
        path:'/prohibit',
        name:'noPermission',
        component:noPermission,
    },

    front_router,
    back_end_router,
]






// WEBPACK FOOTER //
// ./src/config/router-config.js